var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBookmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.538,
    height: 25.12,
    viewBox: "0 0 19.538 25.12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-bookmark",
    d: "M24.247,4.5H10.291A2.787,2.787,0,0,0,7.514,7.291L7.5,29.62l9.769-4.187,9.769,4.187V7.291A2.8,2.8,0,0,0,24.247,4.5Z",
    transform: "translate(-7.5 -4.5)",
    fill: "#6dc1c7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookmark);
export default __webpack_public_path__ + "static/media/bookmark.c68259fd56413013d3e1e365b25ff84a.svg";
export { ForwardRef as ReactComponent };